<div class="ui-g ui-g-nopad hidefilter-pos">
  <div class="ui-g-12 ui-md-12 ui-lg-12 ui-g-nopad mobile-section">
    <div class="float-right">
      <p-checkbox class="padding-0 mr-5" value="0" binary="true" (onChange)="hideFilter($event)">
      </p-checkbox>
      <span class="hidefilter-txt" translate> label_map_view_hide_filter</span>
      <div class="switcher">
        <div class="tab-slider-nav">
          <ul class="tab-slider-tabs" [class.slide]="isSwitcher">
            <li class="tab-slider-trigger" (click)="changeTab()" [class.active]="!isSwitcher">
              <svg width="18px" height="16px" viewBox="0 0 18 16" version="1.1" xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink">
                <g id="Designs" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                  <g id="4-Shift-Calendar-Team-Member" transform="translate(-1195.000000, -98.000000)"
                    [attr.fill]="!isSwitcher ? '#334CBD' : '#778394'" fill-rule="nonzero">
                    <g id="Group-13" transform="translate(85.000000, 80.000000)">
                      <g id="Toggle" transform="translate(1083.000000, 8.000000)">
                        <g id="Group-14" transform="translate(3.000000, 3.000000)">
                          <g id="calendar" transform="translate(24.000000, 7.000000)">
                            <path
                              d="M0.527386455,13.8666667 L3.16409876,13.8666667 L3.16409876,15.4666667 C3.16409876,15.7612089 3.40020756,16 3.69144122,16 L17.4726575,16 C17.7638912,16 18,15.7612089 18,15.4666667 L18,1.6 C18,1.30545778 17.7638912,1.06666667 17.4726575,1.06666667 L14.8359452,1.06666667 L14.8359452,0.533333333 C14.8359452,0.238791111 14.5998364,0 14.3086028,0 C14.0173691,0 13.7812603,0.238791111 13.7812603,0.533333333 L13.7812603,1.06666667 L11.1093918,1.06666667 L11.1093918,0.533333333 C11.1093918,0.238791111 10.873283,0 10.5820494,0 C10.2908157,0 10.0547069,0.238791111 10.0547069,0.533333333 L10.0547069,1.06666667 L7.41799461,1.06666667 L7.41799461,0.533333333 C7.41799461,0.238791111 7.18188582,0 6.89065215,0 C6.59941849,0 6.36330969,0.238791111 6.36330969,0.533333333 L6.36330969,1.06666667 L3.69144122,1.06666667 C3.40020756,1.06666667 3.16409876,1.30545778 3.16409876,1.6 L3.16409876,4.8 C3.16409876,8.73066667 1.5488488,11.7545244 0.189781811,12.9236267 C0.019204103,13.0673778 -0.0440418362,13.3037511 0.0315087604,13.5149156 C0.107129669,13.7260444 0.305340122,13.8666667 0.527386455,13.8666667 Z M16.9453151,14.9333333 L4.21878368,14.9333333 L4.21878368,13.8666667 L14.3086028,13.8666667 C14.4319658,13.8666667 14.5514264,13.8229333 14.6462074,13.74304 C15.2801434,13.2090311 16.2620902,11.9376356 16.9453151,10.3092622 L16.9453151,14.9333333 Z M4.21878368,2.13333333 L6.36330969,2.13333333 L6.36330969,2.66666667 C6.36330969,2.96120889 6.59941849,3.2 6.89065215,3.2 C7.18188582,3.2 7.41799461,2.96120889 7.41799461,2.66666667 L7.41799461,2.13333333 L10.0547069,2.13333333 L10.0547069,2.66666667 C10.0547069,2.96120889 10.2908157,3.2 10.5820494,3.2 C10.873283,3.2 11.1093918,2.96120889 11.1093918,2.66666667 L11.1093918,2.13333333 L13.7812603,2.13333333 L13.7812603,2.66666667 C13.7812603,2.96120889 14.0173691,3.2 14.3086028,3.2 C14.5998364,3.2 14.8359452,2.96120889 14.8359452,2.66666667 L14.8359452,2.13333333 L16.9453151,2.13333333 L16.9453151,4.26666667 L4.21878368,4.26666667 L4.21878368,2.13333333 Z M4.20974855,5.33297778 L16.9359635,5.33297778 C16.8171357,8.71626667 15.5331974,11.37824 14.1018142,12.8 L1.72687962,12.8 C3.34873893,10.7100089 4.12273704,7.98869333 4.20974855,5.33297778 Z"
                              id="Shape"></path>
                            <path
                              d="M11.2824586,11.4285714 C11.6452578,11.4285714 11.967081,11.3396128 12.2479282,11.1616954 C12.5287753,10.9837781 12.7451657,10.7305076 12.8970994,10.4018838 C13.0490331,10.0732601 13.125,9.69230769 13.125,9.25902669 L13.125,9.25902669 L13.125,9.02982732 C13.125,8.60282575 13.0494936,8.22396651 12.8984807,7.89324961 C12.7474678,7.56253271 12.5343002,7.30716902 12.2589779,7.12715856 C11.9836556,6.94714809 11.6682781,6.85714286 11.3128453,6.85714286 L11.3128453,6.85714286 L10.125,6.85714286 L10.125,11.4285714 L11.2824586,11.4285714 Z M11.2796961,10.7943485 L10.823895,10.7943485 L10.823895,7.49764521 L11.3128453,7.49764521 C11.6738029,7.49764521 11.9491252,7.62846677 12.1388122,7.89010989 C12.3284991,8.15175301 12.4233425,8.53061224 12.4233425,9.0266876 L12.4233425,9.0266876 L12.4233425,9.28100471 C12.4196593,9.76870748 12.3197514,10.1428571 12.1236188,10.4034537 C11.9274862,10.6640502 11.6461786,10.7943485 11.2796961,10.7943485 L11.2796961,10.7943485 Z"
                              id="D" stroke="#334CBD" stroke-width="0.551470588"></path>
                            <polygon id="1" stroke="#334CBD" stroke-width="0.551470588"
                              points="8.25 11.4285714 8.25 6.85714286 8.17237062 6.85714286 6.75 7.51109807 6.75 8.1525374 7.64398998 7.77080278 7.64398998 11.4285714">
                            </polygon>
                          </g>
                        </g>
                      </g>
                    </g>
                  </g>
                </g>
              </svg>
              <span class="label" translate>label_week_title</span>
            </li>
            <li class="tab-slider-trigger" (click)="changeTab()" [class.active]="isSwitcher">
              <svg width="16px" height="16px" viewBox="0 0 16 16" version="1.1" xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink">
                <g id="Designs" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                  <g id="4-Shift-Calendar-Team-Member" transform="translate(-1312.000000, -98.000000)"
                    [attr.fill]="isSwitcher ? '#334CBD' : '#778394'" fill-rule="nonzero">
                    <g id="Group-13" transform="translate(85.000000, 80.000000)">
                      <g id="Toggle" transform="translate(1083.000000, 8.000000)">
                        <g id="Group-12" transform="translate(116.000000, 3.000000)">
                          <g id="24-hours" transform="translate(28.000000, 7.000000)">
                            <path
                              d="M7.55381434,10.0311591 C7.55381434,9.69142591 7.27801375,9.41601779 6.93779648,9.41601779 L6.12206563,9.41601779 C6.83128699,8.70774414 7.55381434,7.78324833 7.55381434,6.95545273 C7.55381434,5.93625331 6.72641257,5.11002893 5.70576076,5.11002893 C4.68510894,5.11002893 3.85770717,5.93625331 3.85770717,6.95545273 C3.85770717,7.29518587 4.13350776,7.57059399 4.47372503,7.57059399 C4.8139423,7.57059399 5.08974289,7.29518587 5.08974289,6.95545273 C5.08974289,6.61571959 5.36554349,6.34031146 5.70576076,6.34031146 C6.04597803,6.34031146 6.32177862,6.61571959 6.32177862,6.95545273 C6.32177862,7.52372023 5.17037963,8.73899331 4.1037447,9.53904604 C3.89156793,9.69795207 3.80506219,9.97463149 3.88900788,10.225859 C3.97295356,10.4770864 4.20850418,10.6464593 4.47372503,10.6463004 L6.93779648,10.6463004 C7.27801375,10.6463004 7.55381434,10.3708922 7.55381434,10.0311591 L7.55381434,10.0311591 Z"
                              id="Path"></path>
                            <path
                              d="M9.40186793,5.11002893 C9.06165066,5.11002893 8.78585007,5.38543706 8.78585007,5.7251702 L8.78585007,8.18573526 C8.78585007,8.5254684 9.06165066,8.80087652 9.40186793,8.80087652 L11.2499215,8.80087652 L11.2499215,10.0311591 C11.2499215,10.3708922 11.5257221,10.6463003 11.8659394,10.6463003 C12.2061567,10.6463003 12.4819572,10.3708922 12.4819572,10.0311591 L12.4819572,5.7251702 C12.4819572,5.38543706 12.2061567,5.11002893 11.8659394,5.11002893 C11.5257221,5.11002893 11.2499215,5.38543706 11.2499215,5.7251702 L11.2499215,7.57059399 L10.0178858,7.57059399 L10.0178858,5.7251702 C10.0178858,5.38543706 9.7420852,5.11002893 9.40186793,5.11002893 Z"
                              id="Path"></path>
                            <path
                              d="M8.18486304,16 C11.5683804,15.9188843 14.535404,13.7221502 15.5961406,10.5127518 C16.6568773,7.30335345 15.5821841,3.77459269 12.9116829,1.69832061 C10.2411817,-0.377951471 6.55176056,-0.553213568 3.69594088,1.26053641 L3.80177275,0.73194552 C3.86599762,0.399993025 3.64990681,0.0785000994 3.31792837,0.0120974628 C2.98594993,-0.0543051738 2.66252827,0.159273967 2.59376172,0.490318031 L2.15823709,2.66496543 C2.13071971,2.82366727 2.16437,2.98688834 2.25242622,3.12183085 C2.34396088,3.25635402 2.48275761,3.35163687 2.6413183,3.38880216 L4.81961906,3.82376855 C5.15163147,3.88695103 5.47262153,3.67119926 5.53897136,3.34025971 C5.60532119,3.00932017 5.39224904,2.68679917 5.06146767,2.61747653 L4.14976124,2.43557925 C6.53304372,0.797107743 9.69539084,0.851169239 12.0211129,2.57014293 C14.3468349,4.28911662 15.3223871,7.2934344 14.4493454,10.0481461 C13.5763038,12.8028577 11.0474455,14.699693 8.15480137,14.7695307 C7.81458411,14.7778202 7.54551308,15.0599483 7.55381438,15.3996814 C7.56211568,15.7394145 7.84464578,16.0081027 8.18486304,15.9998132 L8.18486304,16 Z"
                              id="Path"></path>
                            <path
                              d="M0.574331964,8.09346407 L0.617453214,8.09346407 C0.94998969,8.09132052 1.22032448,7.82510457 1.22710257,7.49310336 C1.23388066,7.16110216 0.974636028,6.88410513 0.642463345,6.86842958 C0.310290662,6.85275402 0.026041747,7.10410304 0.0014353518,7.43526292 C-0.0215617629,7.77472225 0.23450019,8.06891193 0.574331964,8.09346407 L0.574331964,8.09346407 Z"
                              id="Path"></path>
                            <path
                              d="M3.06920431,13.5497671 C2.86627966,13.821861 2.92130536,14.2064928 3.19240788,14.4109649 C3.29966692,14.489558 3.4289853,14.5324307 3.5620186,14.533501 C3.75554447,14.5323035 3.93757313,14.4415551 4.05483289,14.2878136 C4.25793395,14.0157645 4.20288862,13.6309955 3.93162931,13.4266158 C3.80179668,13.3263244 3.6368215,13.2828192 3.47432953,13.3060225 C3.31183756,13.3292258 3.16568485,13.4171589 3.06920431,13.5497671 L3.06920431,13.5497671 Z"
                              id="Path"></path>
                            <path
                              d="M0.623613393,4.85782101 C0.491204563,5.17037772 0.637299711,5.53096697 0.95010286,5.66365607 C1.02555663,5.69759536 1.10760885,5.71440263 1.19034983,5.71286737 C1.43660091,5.71552541 1.66023789,5.56988275 1.75708626,5.34378261 C1.84401864,5.14159531 1.81632813,4.90845466 1.68444545,4.73218249 C1.55256278,4.55591032 1.33652408,4.46328656 1.11770902,4.48920169 C0.898893966,4.51511682 0.710545777,4.65563371 0.623613393,4.85782101 L0.623613393,4.85782101 Z"
                              id="Path"></path>
                            <path
                              d="M0.845379823,10.5351443 C0.899758315,10.5364994 0.95395732,10.5283811 1.00554447,10.5111538 C1.3339791,10.4246758 1.53003109,10.0887094 1.44344722,9.76073761 C1.35686334,9.43276578 1.02042858,9.23697502 0.691984803,9.32341836 C0.363541029,9.40986171 0.167453492,9.74580738 0.254002675,10.0737883 L0.254002675,10.0803704 C0.32670737,10.3472291 0.568434745,10.5331195 0.845379823,10.5351443 Z"
                              id="Path"></path>
                            <path
                              d="M5.15134468,14.8538666 C5.05354152,15.1780684 5.23465449,15.5205973 5.55791647,15.6227932 C5.61767332,15.6420446 5.67994246,15.652408 5.74272183,15.6535502 C6.04555806,15.6525317 6.30260358,15.4315699 6.34865227,15.1326793 C6.39470095,14.8337888 6.21605286,14.5458925 5.92752719,14.4540248 C5.60264671,14.3507274 5.25535747,14.5296296 5.15134468,14.8538666 L5.15134468,14.8538666 Z"
                              id="Path"></path>
                            <path
                              d="M1.86796947,12.7623863 C1.99161476,12.7617095 2.11205599,12.7230513 2.21293948,12.6516608 C2.34853121,12.5617689 2.44243416,12.4214063 2.47368474,12.2619084 C2.50493531,12.1024105 2.4709314,11.9370582 2.3792643,11.8027659 C2.25601839,11.6203578 2.04468223,11.5174631 1.8248641,11.5328412 C1.60504597,11.5482194 1.41014148,11.6795341 1.31356927,11.8773203 C1.21699706,12.0751066 1.23342873,12.309316 1.35667465,12.4917241 C1.47313653,12.659325 1.66369335,12.7601993 1.86796947,12.7623863 L1.86796947,12.7623863 Z"
                              id="Path"></path>
                          </g>
                        </g>
                      </g>
                    </g>
                  </g>
                </g>
              </svg>
              <span class="label" translate>label_day_title</span>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="containar-layout manage-shift-container" *ngIf="!hideFilterSection">
  <div class="ui-g">
    <div class="ui-g-12">
      <div class="grid-wrap">
        <div class="ui-g-10 mobile-ui">
          <div class="row-wrapper manage-shift-filters">

            

            <div class="form-field ui-g-12 ui-md-4 ui-lg-3 mb-w">
              <div class="form-label">
                <label for="date" translate>label_date</label>
              </div>
              <div class="form-control-c">
                <p-calendar [showIcon]="true" [(ngModel)]="date" (onSelect)="changeFilter()"
                  [placeholder]="'label_date' | translate">
                </p-calendar>
              </div>
            </div>

            <div class="form-field ui-g-12 ui-md-4 ui-lg-2 mb-w" *ngIf="!disableProvider">
              <div class="form-label">
                <label for="availability" translate>label_driver</label>
              </div>
              <div class="form-control-c">
                <p-dropdown [options]="providerList" [(ngModel)]="providerId" (onChange)="onProviderChange()"
                  [placeholder]="'label_all' | translate"  [style]="{'width': '100%'}">
                </p-dropdown>
              </div>
            </div>

            <div class="form-field ui-g-12 ui-md-4 ui-lg-2 mb-w">
              <div class="form-label">
                <label translate>label_service_region</label>
              </div>
              <div class="form-control-c">
                <p-multiSelect autocomplete="off" [options]="serviceRegionList"
                  [defaultLabel]="'label_all' | translate" [style]="{'width': '100%'}"
                  [(ngModel)]="selectedServiceRegionIds" filter="filter" [resetFilterOnHide]="true"
                  (onChange)="filterChange()">
                </p-multiSelect>
              </div>
            </div>

            <div class="form-field ui-g-12 ui-md-4 ui-lg-2 mb-2 mb-w">
              <div class="form-label">
                <label for="availability" translate>label_availability</label>
              </div>
              <div class="form-control-c">
                <p-dropdown [options]="memberShiftAvailabilityAndTimeOffList" [(ngModel)]="selectedAvailability"
                  [style]="{'width': '100%'}" (onChange)="filterChange()" [placeholder]="'label_all' | translate">
                </p-dropdown>
              </div>
            </div>

            <div class="form-field ui-g-12 ui-md-4 ui-lg-2 mb-2 mb-w" style="width: 17%;">
              <div class="form-label">
                <label for="availability" translate>label_user_type</label>
              </div>
              <div class="form-control-c">
                <p-dropdown [style]="{'width': '100%'}" [options]="userList" [(ngModel)]="selectedRole"
                  (onChange)="changeUserFilter()" [disabled]="disableProvider">
                </p-dropdown>
              </div>
            </div>
            <div class="form-field ui-g-12 ui-md-4 ui-lg-2 mb-2 mb-w" *ngIf="showRole">
              <div class="form-label">
                <label for="role" translate>label_role</label>
              </div>
              <div class="form-control-c">
                <!-- <p-dropdown [style]="{'width': '100%'}" [options]="roles" [(ngModel)]="userRoleIds" (onChange)="changeRoleFilter()">
                </p-dropdown> -->
                <p-multiSelect autocomplete="off" [defaultLabel]="'label_all' | translate" [options]="roles"
                  [(ngModel)]="userRoleIds" (onChange)="changeRoleFilter()" [style]="{'width': '100%'}" filter="filter"
                  [resetFilterOnHide]="true">
                </p-multiSelect>
              </div>
            </div>

          </div>

          <div class="manage-shift-search-row">
            <div class="search-custom">
              <input autocomplete="off" type="text" pInputText [(ngModel)]="searchedTeam" (keyup)="searchTeam()"
                [placeholder]=" selectedRole === '20' ? ('label_search_web_portal_member' | translate ): 'label_search_team_member' | translate" />
            </div>
            <div class="display-buttons">
              <i class='fa fa-refresh reste-btn' [class.disabled]="!selectedAvailability && !isDateChanged && !selectedRole && !providerId && !searchedTeam && !selectedServiceRegionIds?.length" (click)="onResetFilter()"></i>
              <button class="save-filter" pButton type="button" [label]="'Save Filter' | translate" [disabled]="!selectedAvailability && !isDateChanged && !selectedRole && !providerId && !selectedServiceRegionIds?.length"
                (click)="saveFilter()"></button>
              <button class="load-more-btn refresh-btn" pButton (click)="loadMore()" [disabled]="disableLoadMore" type="button"
                [label]="'label_load_more' | translate"></button>
            </div>
          </div>


          
        </div>
        <div class="ui-g-2 ui-grid-right">
          <div class="ui-right-wrapper">
            <h4 class="title" translate>label_team_shift_availability</h4>
            <div class="availability-wrapper">
              <div class="ui-availabilty-block" *ngFor="let memberShiftAvailability of memberShiftAvailabilityList">
                <span class="rect-block" [ngClass]="memberShiftAvailability?.value"></span>
                <span class="rect-text">{{memberShiftAvailability?.label}}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="date-wrapper">
        <span class="note">* All the shift timings shown below are in {{timezoneAbbr}} timezone</span>
        <div class="today-slider-wrapper">
          <span class="blue-text" [class.disable]="date.getTime() === minDate.getTime()" (click)="goToToday()"
            translate>label_team_today_title</span>
          <div class="arrow-wrapper">
            <div class="left-arrow" (click)="goToPreviousWeek()">
              <svg width="9px" height="14px" viewBox="0 0 9 14" version="1.1" xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink">
                <g id="Designs" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                  <g id="1-Shift-Calendar" transform="translate(-1369.000000, -255.000000)" fill="#334CBD"
                    fill-rule="nonzero">
                    <g id="Group-38" transform="translate(235.000000, 80.000000)">
                      <g id="Group-34" transform="translate(1068.000000, 172.000000)">
                        <g id="Group-26-Copy"
                          transform="translate(83.317073, 10.000000) scale(-1, 1) translate(-83.317073, -10.000000) translate(66.000000, 3.000000)">
                          <path
                            d="M30.4755865,11.1585366 C30.224678,11.1585366 29.9738005,11.0586925 29.7825052,10.8594241 L23.7628083,4.58571559 C23.3798769,4.18662989 23.3798769,3.53958084 23.7628083,3.1406566 C24.1455847,2.74173235 24.7663183,2.74173235 25.1492807,3.1406566 L30.4755865,8.69198096 L35.8019234,3.14085034 C36.1848547,2.7419261 36.8055264,2.7419261 37.1882718,3.14085034 C37.5713891,3.53977459 37.5713891,4.18682364 37.1882718,4.58590933 L31.1686678,10.8596179 C30.9772796,11.0589185 30.7264021,11.1585366 30.4755865,11.1585366 Z"
                            id="Path-Copy-9"
                            transform="translate(30.475610, 7.000000) scale(-1, 1) rotate(90.000000) translate(-30.475610, -7.000000) ">
                          </path>
                        </g>
                      </g>
                    </g>
                  </g>
                </g>
              </svg>
            </div>
            <div class="right-arrow" [class.disable]="date.setHours(0,0,0,0) >= maxDate.setHours(0,0,0,0)"
              (click)="goToNextWeek()">
              <svg width="9px" height="14px" viewBox="0 0 9 14" version="1.1" xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink">
                <g id="Designs" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                  <g id="1-Shift-Calendar" transform="translate(-1395.000000, -255.000000)" fill="#334CBD"
                    fill-rule="nonzero">
                    <g id="Group-38" transform="translate(235.000000, 80.000000)">
                      <g id="Group-34" transform="translate(1068.000000, 172.000000)">
                        <g id="Group-26-Copy"
                          transform="translate(83.317073, 10.000000) scale(-1, 1) translate(-83.317073, -10.000000) translate(66.000000, 3.000000)">
                          <path
                            d="M4.15851335,11.1585366 C3.90760485,11.1585366 3.65672734,11.0586925 3.46543208,10.8594241 L-2.5542649,4.58571559 C-2.93719625,4.18662989 -2.93719625,3.53958084 -2.5542649,3.1406566 C-2.17148847,2.74173235 -1.55075485,2.74173235 -1.16779252,3.1406566 L4.15851335,8.69198096 L9.4848502,3.14085034 C9.86778155,2.7419261 10.4884532,2.7419261 10.8711986,3.14085034 C11.2543159,3.53977459 11.2543159,4.18682364 10.8711986,4.58590933 L4.85159462,10.8596179 C4.6602064,11.0589185 4.40932889,11.1585366 4.15851335,11.1585366 Z"
                            id="Path-Copy-8"
                            transform="translate(4.158537, 7.000000) rotate(90.000000) translate(-4.158537, -7.000000) ">
                          </path>
                        </g>
                      </g>
                    </g>
                  </g>
                </g>
              </svg>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<app-manage-shifts-team-members-week-list *ngIf="currentPage === 'weekView'" [searchTeam]="sentSearchedTeam" [providerId]="providerId"
  [selectedAvailability]="selectedAvailability" [selectedRole]="selectedRole" [userRoleIds]="userRoleIds"
  [fromDate]="date" [offset]="offset" (totalCount)="getTotalCount($event)"
  [serviceRegionIds]="selectedServiceRegionIds"
  [isPastDate]="date.setHours(0,0,0,0) &lt; minDate.setHours(0,0,0,0)"
  (offsetEmmiter)="updateOffset($event)"></app-manage-shifts-team-members-week-list>

<app-manage-shifts-team-members-day-list *ngIf="currentPage === 'dayView'" [searchTeam]="sentSearchedTeam" [providerId]="providerId"
  [selectedAvailability]="selectedAvailability" [selectedRole]="selectedRole" [userRoleIds]="userRoleIds"
  [fromDate]="date" [offset]="offset" (totalCount)="getTotalCount($event)"
  [serviceRegionIds]="selectedServiceRegionIds"
  [isPastDate]="date.setHours(0,0,0,0) &lt; minDate.setHours(0,0,0,0)"></app-manage-shifts-team-members-day-list>

<p-dialog [blockScroll]="true" modal="true" [draggable]="false" position="center" styleClass="assign-search"
  [(visible)]="openProviderScheduleDialog" (onHide)="providerSchedulePopupCancel()" [style]="{width: '95%'}">
  <p-header>
    <label class="popup-import-providers" translate>label_shift_upload</label>
  </p-header>
  <!-- New: enable this on import v2 -->
  <p-scrollPanel [style]="{ width: '100%', height: '520px'  }">
    <div class="ui-g form-container">
      <form class="ui-g-12 ui-g-nopad" [formGroup]="Form">
        <div class="ui-g-12 ui-g-nopad">
          <div class="form-field ui-g-6 text-center">
            <div class="import-img-ml-8">
              <img src="/assets/images/temp/excel.png" class="uploaded-img">
            </div>
            <app-file-uploader (fileUpload)="onUploadScheduleProviderExcel($event)" [uploadButtonLabel]="chooseLabel"
              accept=".xlsx">
            </app-file-uploader>
            <span>{{ scheduleProviderFileName }}</span>
          </div>
          <div class="form-field ui-g-6 text-center">
            <div>
              <img src="/assets/images/temp/download.png" class="uploaded-img">
            </div>
            <div style="padding:0.571em 1em">
              <button pButton type="button" icon="fa fa-download" (click)="providerScheduleTemplate()"
                label="Download Template"></button>
            </div>
          </div>
        </div>

        <div class="ui-g-12 ui-g-nopad imp-shift">
          <div class="form-field ui-g-4 mr-230">
            <div class="form-label">
              <label for="serviceType" translate>label_import_for</label>
            </div>
            <div class="form-control-c">
              <p-dropdown [options]="repeatScheduleOptions" [(ngModel)]="repeatSchedule"
                [ngModelOptions]="{standalone: true}" (onChange)="onChangeImport($event)">
              </p-dropdown>
            </div>
          </div>
          <div class="form-field ui-g-4">
            <div class="form-label">
              <label for="serviceType" translate>Timezone</label>&nbsp;
            </div>
            <div class="form-control-c">
              <p-dropdown [options]="timezoneOptions" [(ngModel)]="scheduleTimezoneName"
                [ngModelOptions]="{standalone: true}">
              </p-dropdown>
            </div>
          </div>
        </div>


        <!-- NEW: enable for new shift module -->
        <div class="ui-g-12 ui-g-nopad">
          <div class="ui-g-12 note-lable">
            <b>Note:</b> To enter the staff schedules, please click on the "download template" button to download the
            excel template. Update the downloaded template with accurate email, name, and staff schedule and
            save the template afterwards. Please click on the "<b>Choose File</b>" button to pick the updated excel
            template and click on the "<b>Import For</b>" drop-down menu to choose the required timeframe ("<b>Specific
              Date</b>" or "<b>For Next 3 Months</b>") for the staff schedule.<br>
            <ul class="ui-g-12 pl-15">
              <li>
                The staff schedule for "<b>Specific Date</b>" can be defined using the start & end date-time
                combinations. e.g., Start: "7:00 AM", End: "8:00 PM".
              </li>
              <li>
                For multiple shift entries within the same day, use the pipe symbol "|" to clearly define each
                shift. Take for example, Start: "7:00 AM | 1:00 PM | 7:00 PM", End: "10:00 AM | 5:00 PM |
                11:00 PM", means that the first shift starts at 7:00 AM and ends at 10:00 AM, the second
                shift starts at 1:00 PM and ends at 5:00 PM and the third shift starts at 7:00 PM and ends at
                11:00 PM.
              </li>
              <li>
                To make use of the "<b>For Next 3 Months</b>" under the "<b>Import For</b>" drop-down menu,
                the user will have to update the excel template for 7 consecutive days which are in
                future. And the respective shift schedule will be recursive for the next 3 months from the start date.
              </li>
              <li>
                <b translate>label_example</b><br />
                <p translate>label_import_text</p>
                <table class="import-sample-table">
                  <tr>
                    <th translate>label_import_start<br />(10/17/2023)</th>
                    <th translate>label_import_end<br />(10/17/2023)</th>
                    <th translate>label_import_start<br /> (10/18/2023)</th>
                    <th translate>label_import_end<br /> (10/18/2023)</th>
                    <th translate>label_import_start<br /> (10/19/2023)</th>
                    <th translate>label_import_end<br /> (10/19/2023)</th>
                    <th translate>label_import_start<br /> (10/20/2023)</th>
                    <th translate>label_import_end<br /> (10/20/2023)</th>
                    <th translate>label_import_start<br /> (10/21/2023)</th>
                    <th translate>label_import_end<br /> (10/21/2023)</th>
                    <th translate>label_import_start<br /> (10/22/2023)</th>
                    <th translate>label_import_end<br /> (10/22/2023)</th>
                    <th translate>label_import_start<br /> (10/23/2023)</th>
                    <th translate>label_import_end<br /> (10/23/2023)</th>
                    <th></th>
                  </tr>
                  <tr>
                    <td>09:00 AM</td>
                    <td>05:00 PM</td>
                    <td>09:00 AM | 01:30 PM</td>
                    <td>12:15 PM | 04:00 PM</td>
                    <td>09:00 AM</td>
                    <td>05:00 PM</td>
                    <td>09:00 AM | 01:30 PM</td>
                    <td>12:15 PM | 04:00 PM</td>
                    <td>09:00 AM</td>
                    <td>05:00 PM</td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                  </tr>
                </table>
                <!-- <p>As 1 week was picked under the "<b>Recur Every</b>" drop down-menu and the "<b>End By</b>" date was picked as 31st of December 2023, 
            the above schedule shall repeat itself every week for the respective team member until 31st of December 2023. Similarly, if the user selects 
            option as 2, 3 or 4 weeks, the user is expected to update Shift Date & Time in the excel template with those many weeks.</p> -->
              </li>

            </ul>
          </div>
        </div>

        <div class="ui-g-12 ui-g-nopad form-buttons">
          <button class="save-btn" pButton type="button" label="Import" [disabled]="!scheduleproviderExcelId"
            (click)="uploadScheduleProviderExcelData()"></button>
          <button class="cancel-btn" pButton type="button" label="Cancel"
            (click)="providerSchedulePopupCancel()"></button>
        </div>
      </form>
    </div>
  </p-scrollPanel>
</p-dialog>

<p-dialog [blockScroll]="true" modal="true" [draggable]="false" position="center" autoResize="false" responsive="true"
  styleClass="assign-search" [(visible)]="importErrorPopUp" [header]="'Import log:'" (onHide)="closeErrorPopUp()"
  [style]="{ width: '650px' }">
  <div>
    <!-- <p class="ui-g-12 header-dialog-heading" style="padding: 9px; padding-top: 0; font-size: 16px">
      {{ fileInportHeader }}
    </p> -->
    <p class="ui-g-12 header-dialog-heading" style="padding: 9px; padding-top: 0; font-size: 12px">
      {{ fileInportMsg }}
    </p>
  </div>
  <div class="ui-g-12 ui-g-nopad form-buttons">
    <button class="cancel-btn" pButton type="button" label="Close" (click)="closeErrorPopUp()"></button>
  </div>
</p-dialog>

<p-dialog [blockScroll]="true" modal="true" [draggable]="false" position="center" autoResize="false" responsive="true"
  styleClass="assign-search" [(visible)]="successErrorPopUp" [header]="'Import log:'" (onHide)="uploadPopupCancel()"
  [style]="{ width: '650px' }">
  <div class="ui-g-12">
    <p *ngIf="successErrorArray?.message" style="font-size: 14px; font-weight: normal">
      {{ successErrorArray?.message }}
    </p>
  </div>

  <div *ngIf="!successErrorArray?.status" class="ui-g-12 header-dialog-heading"
    style="border-radius: 2px; border: 1px solid rgb(169, 169, 169)">
    <p-scrollPanel [style]="{ width: '100%', height: '260px' }">
      <div *ngFor="let item of successErrorArray?.errors">
        <p style="font-size: 12px; font-weight: normal" *ngFor="let ele of item?.errorList">
          {{ ele }}
        </p>
      </div>
    </p-scrollPanel>
  </div>

  <div *ngIf="successErrorArray?.status" [hidden]="true">
    <!-- <p *ngIf="successErrorArray?.message" style="font-size: 14px; font-weight: normal">
      {{ successErrorArray?.message }}
    </p> -->
    <p style="font-size: 14px; font-weight: normal ; padding-left: 9px;">
      Inserted Count: {{ successErrorArray?.insertedPatientCount }}
    </p>
    <p style="font-size: 14px; font-weight: normal; padding-left: 9px;">
      Updated Count: {{ successErrorArray?.updatedPatientCount }}
    </p>
  </div>

  <div class="ui-g-12 ui-g-nopad form-buttons">
    <button class="cancel-btn" pButton type="button" label="Close" (click)="closeSuccessErrorPopUp()"></button>
  </div>
</p-dialog>

<p-dialog [blockScroll]="true" modal="true" [showHeader]="false" position="center" responsive="true"
  [style]="{width: '450px'}" [(visible)]="exportPopup">
  <div class="ui-g form-container">
    <div class="ui-g-12">
      <h3 translate>label_export_schedules</h3>
    </div>
    <div class="ui-g-12 ui-md-12 ui-lg-12 ui-g-nopad">
      <div class="ui-g">
        <div class="form-field ui-g-12 ui-md-12 ui-lg-12">
          <!-- <div class="form-label">
              <label for="serviceType" translate>label_provider</label>
            </div>
              <div class="form-control-c" *ngIf="roleId !== '6' && roleId !== '11'">
                <p-dropdown autocomplete="off" [(ngModel)]="providerIdExport" [options]="providerNameListExport" [placeholder]="'Select' | translate"
                 [style]="{'width': '100%'}" filter="filter" [resetFilterOnHide]="true">
                </p-dropdown>
              </div> -->
          <div class="form-control-c" *ngIf="roleId === '6' || roleId === '11'">
            <input autocomplete="off" type="text" [(ngModel)]="loggedInUsername" pInputText [disabled]="true" />
          </div>
        </div>
        <div class="form-field ui-g-12 ui-md-12 ui-lg-12 ui-g-nopad">
          <div class="form-field ui-g-12 ui-md-6 ui-lg-6">
            <div class="form-label">
              <label for="startDate" translate>label_from_date</label>
              <label class="asterisk">*</label>
            </div>
            <div class="form-control-c">
              <p-calendar [(ngModel)]="fromDate" [maxDate]="maxDate" [defaultDate]="maxDate" [showIcon]="true"
                dateFormat="{{dateFormat}}" [placeholder]="'label_date' | translate">
              </p-calendar>
            </div>
            <div class="form-errors" *ngIf="!fromDate" translate>
              error_date_required
            </div>

          </div>
          <div class="form-field ui-g-12 ui-md-6 ui-lg-6">
            <div class="form-label">
              <label for="toDate" translate>label_to_date</label>
              <label class="asterisk">*</label>
            </div>
            <div class="form-control-c">
              <p-calendar [(ngModel)]="toDate" [showIcon]="true" [defaultDate]="maxDate" [minDate]="fromDate"
                dateFormat="{{dateFormat}}" [placeholder]="'label_to_date' | translate"
                (onSelect)="exportToDateValidation()"></p-calendar>
            </div>
            <div class="form-errors" *ngIf="!toDate" translate>
              error_to_date_required
            </div>
          </div>
        </div>
        <div class="form-field ui-g-12 ui-md-12 ui-lg-12 txt-center but-right mt-10">
          <button class="cancel-btn mr-20" pButton type="button" [label]="'label_cancel' | translate"
            (click)="hideExport()"></button>
          <button pButton class="save-btn" type="button" [disabled]="!fromDate || !toDate || !dateDiffFlag"
            (click)="exportData()" [label]="'Export' | translate"></button>

        </div>
      </div>
    </div>
  </div>
</p-dialog>